import * as yup from 'yup';

import { phoneNumberSchema } from '../common';

export const beneficiaryRequestSchema = yup
  .object({
    firstName: yup.string().trim().max(128).required(),
    lastName: yup.string().trim().max(128).required(),
    relationship: yup.string().trim().max(64).required(),
    percentage: yup.number().integer().min(0).max(100).required(),
    phoneNumber: phoneNumberSchema.notRequired().nullable().max(32),
  })
  .defined();

export type BeneficiaryRequestSchema = yup.InferType<typeof beneficiaryRequestSchema>;
